export function bFileDropzoneDirective() {
  'ngInject';

  let directive = {
    restrict: 'A',
    scope: {
      filesToUpload: '='
    },
    link: fileDropzoneLink
  };

  return directive;
}

function fileDropzoneLink(scope, element) {
  var fileObjectsArray = [];

  element.bind('dragover', function(e) {
    if (e != null) {
      e.preventDefault();
    }
    if (e.target === this) angular.element(e.target).addClass('file-drop-zone-over');
    return false;
  });

  element.bind("dragenter", function(e) {
    if (e != null) {
      e.preventDefault();
    }
    e.dataTransfer.effectAllowed = 'copy';
    if (e.target === this) angular.element(e.target).addClass('file-drop-zone-over');

  });

  element.bind("dragleave", function(e) {
    if (e != null) {
      e.preventDefault();
    }
    angular.element(e.target).removeClass('file-drop-zone-over');
  });

  element.bind("drop", function(e) {
    angular.element(e.target).removeClass('file-drop-zone-over');

    if (e.preventDefault) {
      e.preventDefault();
    }

    if (e.stopPropogation) {
      e.stopPropogation();
    }

    angular.forEach(e.dataTransfer.files, function(file) {
      var reader = new FileReader();
      reader.onload = function() {
        scope.$apply(function() {
          fileObjectsArray.push(file);
        });
      };
      reader.readAsDataURL(file);
    });
    scope.filesToUpload = fileObjectsArray;
  });

  return false;
}
